import { useAppDispatch, useAppSelector } from 'app/hooks';
import DataRequired from 'components/data-required';
import { getDataRequiredAsync, selectDataRequired, selectPaymentData } from 'features/payment/payment-slice';
import { useEffect } from 'react';
import styles from './styles.module.scss';
import { PaymentMethodTypes } from '../../../constants';
import { LoadingData } from 'components/loading-data';

const CardSection = () => {
  const { loading, inputs } = useAppSelector(selectDataRequired);
  const paymentData = useAppSelector(selectPaymentData);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const firstPmId =
      paymentData?.paymentMethodsGrouped && paymentData.paymentMethodsGrouped[PaymentMethodTypes.CREDIT_CARD][0];
    if (firstPmId) dispatch(getDataRequiredAsync(firstPmId));
  }, []);

  return (
    <div className={styles.card_section}>
      {loading && <LoadingData />}
      {inputs && <DataRequired paymentMethodType={PaymentMethodTypes.CREDIT_CARD} />}
    </div>
  );
};

export default CardSection;
